import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import { Helmet } from "@/components/Helmet";

const Security = () => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Helmet>
        <title>Security | ShadowScan</title>
        <meta
          name="description"
          content="Responsible disclosure guidelines and security contact information for ShadowScan."
        />
      </Helmet>
      <Navigation />
      <main className="flex-grow pt-24">
        <section className="relative py-16 overflow-hidden">
          <div className="absolute inset-0 bg-grid-pattern opacity-20 -z-10" />
          <div className="absolute inset-0 bg-gradient-to-b from-primary/10 via-transparent to-transparent -z-10" />
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto">
              <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-primary/30 bg-primary/5 mb-6">
                <span className="font-mono text-sm text-primary">// SECURITY</span>
              </div>
              <h1 className="text-4xl md:text-5xl font-heading font-bold mb-3">Security</h1>
              <p className="text-muted-foreground">Responsible disclosure guidance for ShadowScan.</p>
            </div>
          </div>
        </section>

        <section className="py-12">
          <div className="container mx-auto px-4">
            <div className="max-w-3xl mx-auto cyber-card rounded-xl p-8 border-primary/30 space-y-6 text-sm text-muted-foreground">
              <p>
                ShadowScan welcomes responsible disclosure of security issues. Please report vulnerabilities privately and do not publicly disclose without coordination.
              </p>

              <div className="space-y-2">
                <h2 className="text-lg font-heading font-semibold text-foreground">What to include</h2>
                <ul className="list-disc pl-6 space-y-1">
                  <li>Target URL or affected system</li>
                  <li>Steps to reproduce</li>
                  <li>Potential impact</li>
                </ul>
              </div>

              <div className="space-y-2">
                <h2 className="text-lg font-heading font-semibold text-foreground">What not to do</h2>
                <ul className="list-disc pl-6 space-y-1">
                  <li>No exploitation beyond proof of concept</li>
                  <li>No denial-of-service or disruption</li>
                </ul>
              </div>

              <div className="space-y-2">
                <h2 className="text-lg font-heading font-semibold text-foreground">Contact</h2>
                <p>
                  Email: <a className="text-primary hover:underline" href="mailto:security@shadowscan.com.au">security@shadowscan.com.au</a>
                </p>
                <p>Encrypted reports are supported via `/.well-known/security.txt`.</p>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default Security;
